import { FunctionFactory } from 'survey-core';
import { loc, locWrap, tSurvey } from '../i18n/survey';

enum Goals {
  BuildMuscleAndLoseFat = "Lose Fat Most Important",
  BuildMuscle = "Build Muscle Most Important",
  LoseFat = "Lose Weight",
}

const goalsQuestion = {
  name: "goals",
  title: loc("quiz.goals.title"),
  type: "radiogroup",
  description: loc("quiz.goals.description"),
  choices: [
    {
      value: Goals.LoseFat,
      text: locWrap("quiz.goals.choices.loseWeight", (s) => `<div class='icon-button'><div>🔥</div><div>${s}</div></div>`),
    },
    {
      value: Goals.BuildMuscle,
      text: locWrap("quiz.goals.choices.buildMuscle", (s) => `<div class='icon-button'><div>💪</div><div>${s}</div></div>`),
    },
    {
      value: Goals.BuildMuscleAndLoseFat,
      text: locWrap("quiz.goals.choices.recomp", (s) => `<div class='icon-button'><div>🔄</div><div>${s}</div></div>`),
    },
  ],
  isRequired: true,
};

function renderGoalsText(params: any[]): string {
  if (params === undefined || params === null) return "";
  switch (params[0] as Goals) {
    case Goals.LoseFat:
      return tSurvey("quiz.goals.goalsText.loseWeight");
    case Goals.BuildMuscle:
      return tSurvey("quiz.goals.goalsText.buildMuscle");
    case Goals.BuildMuscleAndLoseFat:
      return tSurvey("quiz.goals.goalsText.recomp");
  }
}

const goalsTextExpression = {
  name: "goalsText",
  expression: "renderGoalsText({goals})",
};

FunctionFactory.Instance.register("renderGoalsText", renderGoalsText);

export { Goals, goalsQuestion, goalsTextExpression };

